import blobToBuffer from 'blob-to-buffer';
import $root from '../../static/proto-bundle';

class ChatBuider {

  createTextMessageBody(text, userId) {
    const builder = $root.lookup('PutMessageRequest');
    const BodyTypes = $root.lookup('BodyTypes');
    const Text = $root.lookup('BodyTypes.Text');
    const now = new Date().getTime();
    const id = this.generateUUID();

    const bodyType = BodyTypes.create({
      text: Text.create({
        body: text
      })
    });

    const payload = builder.create({
      message: {
        messageId: id,
        createdAtMillis: now,
        creatorId: userId,
        deleted: false,
        bodyType: BodyTypes.encode(bodyType).finish()
      }
    });

    return builder.encode(payload).finish();
  }

  createPingMessageBody(userId) {
    const builder = $root.lookup('PutMessageRequest');
    const BodyTypes = $root.lookup('BodyTypes');
    const Ping = $root.lookup('BodyTypes.Ping');
    const now = new Date().getTime();
    const id = this.generateUUID();

    const bodyType = BodyTypes.create({
      ping: Ping.create({
        ping: 1
      })
    });

    const payload = builder.create({
      message: {
        messageId: id,
        createdAtMillis: now,
        creatorId: userId,
        deleted: false,
        bodyType: BodyTypes.encode(bodyType).finish()
      }
    });

    return builder.encode(payload).finish();
  }

  createImageMessageBody(data, userId) {
    const builder = $root.lookup('PutMessageRequest');
    const BodyTypes = $root.lookup('BodyTypes');
    const Image = $root.lookup('BodyTypes.Image');
    const now = new Date().getTime();
    const id = this.generateUUID();

    const bodyType = BodyTypes.create({
      image: Image.create(data)
    });

    const payload = builder.create({
      message: {
        messageId: id,
        createdAtMillis: now,
        creatorId: userId,
        deleted: false,
        bodyType: BodyTypes.encode(bodyType).finish()
      }
    });

    return builder.encode(payload).finish();
  }

  createRpcSendMessageClientRequestBody(text) {
    const builder = $root.lookup('RpcSendMessageClientRequest');
    const BodyTypes = $root.lookup('BodyTypes');
    const Text = $root.lookup('BodyTypes.Text');
    const bodyType = BodyTypes.create({
      text: Text.create({
        body: text
      })
    });
    const payload = builder.create({
      body: bodyType
    });
    return builder.encode(payload).finish();
  }

  decodePutMessageResponse(payload) {
    const container = $root.lookup('PutMessageResponse');
    const bodyTypes = $root.lookup('BodyTypes');
    const message = container.decode(new Uint8Array(payload));
    message.message.bodyType = bodyTypes.decode(new Uint8Array(message.message.bodyType));
    return message;
  }

  decodeChatResponse(payload) {
    const container = $root.lookup('ChatResponse');
    const message = container.decode(new Uint8Array(payload));
    message.messages.forEach(msg => {
      msg.bodyType = this.decodeBodyTypes(msg.bodyType);
    });
    return message;
  }

  decodeBodyTypes(payload) {
    const bodyTypes = $root.lookup('BodyTypes');
    return bodyTypes.decode(new Uint8Array(payload));
  }

  decodeChatChannel(payload, callback) {
    blobToBuffer(payload, (err, buffer) => {
      const container = $root.lookup('ChatChannel');
      const message = container.decode(new Uint8Array(buffer));
      const normalized = this.adjustToPhoenixProtocol(message.toJSON());
      if (normalized.payload.chat && normalized.payload.chat.newMessage) {
        const decodedMessage = message.payload.chat.newMessage;
        decodedMessage.bodyType = this.decodeBodyTypes(message.payload.chat.newMessage.bodyType);
        if (callback) {
          callback(decodedMessage);
        }
      }
    });
  }

  adjustToPhoenixProtocol(message) {
    if (message.event === 'phx_reply' && message.replyStatus) {
      if (!message.payload) {
        message.payload = {};
      }
      message.payload.status = message.replyStatus;
    }

    if (message.event === 'phx_close') {
      message.payload = {
        status: 'ok'
      };
    }

    return message;
  }

  generateUUID() {
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    return `${s4()}${s4()}${s4()}${s4()}`;
  }

}

export default ChatBuider;



// WEBPACK FOOTER //
// ./src/services/chat-builder.service.js